import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);



const siteHeader = document.querySelector('.siteHeader');

// ScrollTrigger.create({
//     trigger: siteHeader,
//     start: '100px top',
//     end: 99999,
//     toggleClass: {className: 'siteHeader--sticky', targets: '.siteHeader'}
// });